const $ = jQuery.noConflict();

'use strict';
const Tabs = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domTabs: $('.js-tabs__content-tab-block'),
	$domTabsLink: $('.js-tabs__content-tab-btn'),

	/** @description Initialize */
	init: function() {
		this.tabsInit();
	},

	tabsInit: ()=> {
		Tabs.$domTabsLink.on('click', function(e) {
			e.preventDefault();
			Tabs.$domTabsLink.removeClass('is-active-tab');
			$(this).addClass('is-active-tab');
			const sel = this.getAttribute('data-toggle-target');
			Tabs.$domTabs.removeClass('active').filter(sel).addClass('active');
		});
	},
};

export default Tabs;